import { render, staticRenderFns } from "./ProfileCard.vue?vue&type=template&id=e565c6f2&"
import script from "./ProfileCard.vue?vue&type=script&lang=js&"
export * from "./ProfileCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e565c6f2')) {
      api.createRecord('e565c6f2', component.options)
    } else {
      api.reload('e565c6f2', component.options)
    }
    module.hot.accept("./ProfileCard.vue?vue&type=template&id=e565c6f2&", function () {
      api.rerender('e565c6f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cards/Profile/ProfileCard.vue"
export default component.exports